import getAxios from './axiosService'

const listService = {

  getIndexPage () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/novel/home/index')
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  },
  getCommonInfo () {
    let branchId = userService.getBranchId();
    let url = '/api/common/info/v2/' + branchId;
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(url)
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  },
  bookInitSearch () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/novel/init_search')
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  },

  getCategory () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/novel/category')
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get comic category with error', res)
            reject(res.data)
          }
        })
    })
  },
  getBooks (category, currentPage, publishStatus, channel) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.post(`/api/novel/query/${channel}/${publishStatus}/${category}/${currentPage}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getLatest (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/novel/recent_update?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get latest comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getRanked (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/novel/week_rank?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get ranked comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getVIP (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/novel/vip?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get VIP comics with error', res)
            reject(res.data)
          }
        })
    })
  },

  getMoreRecommend (target) {
    return getDetailList(target, 'e_recommend')
  },

  getMoreNew (target) {
    return getDetailList(target, 'new')
  },

  getMoreHot (target) {
    return getDetailList(target, 'hot')
  },

  getMoreList (target, type) {
    return getDetailList(target, type)
  },
  getRefreshList(type, currentPage) {
    return getHomeDetailList(type, currentPage);
  },
  getNewList (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/novel/new/${target}`)
        .then(res => {
          if (res.status === 200 && res.data.result) {
            resolve(res.data)
          } else {
            console.error('Get home detail list with error', res)
            reject(res.data)
          }
        })
    })
  },
  /**
   * 更新列表，需要dynamicApi
   * @param currentPage
   * @returns {Promise<unknown>}
   */
  getUpdateList (category, pageSize, currentPage) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(false)
      axios.get(`/api/novel/today_update?category=${category}&pageSize=${pageSize}&currentPage=${currentPage}`)
        .then(res => {
          if (res.status === 200 && res.data.result) {
            resolve(res.data)
          } else {
            console.error('Get home detail list with error', res)
            reject(res.data)
          }
        })
    })
  },

  getDetail (id) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/novel/detail/${id}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error(`Get book ${id} detail with error`, res)
            reject(res.data)
          }
        })
    })
  },
  getChapters (id, currentPage = 1) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios({
        method: 'post',
        url: `/api/novel/catalogue?bookId=${id}&currentPage=${currentPage}`,
        data: {
          bookId: id
        },
        transformRequest: [
          function (data) {
            let ret = ''
            for (const item in data) {
              ret += `${encodeURIComponent(item)}=${encodeURIComponent(data[item])}&`
            }
            return ret
          }
        ]
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  getChapterImg (id, number) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.get(`/api/novel/read_chapter?bookId=${id}&number=${number}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  buyChapter (id) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post('/api/novel/chapter/buy', {}, {
        params: {
          chapterId: id
        }
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  }

}

function getDetailList (target, type) {
  return new Promise((resolve, reject) => {
    const axios = getAxios(true)
    axios.get(`/api/novel/showcase/detail/${type}/${target}`)
      .then(res => {
        if (res.status === 200 && res.data.result) {
          resolve(res.data)
        } else {
          console.error('Get home detail list with error', res)
          reject(res.data)
        }
      })
  })
}

function getHomeDetailList(type, currentPage) {
  return new Promise((resolve, reject) => {
    let axios = getAxios(true);
    axios.get(`/api/novel/showcase/detail/${type}/${currentPage}`)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get home detail list with error', res);
          reject();
        }
      })
  })
};



export default listService



// WEBPACK FOOTER //
// ./src/services/novelService.js